import * as organizationConstants from '../constants/organizations';

export default function bucketsByOrganization(state = {}, action) {
    switch (action.type) {
        case organizationConstants.FETCH_ORGANIZATION_BUCKETS_SUCCESS:
            const { buckets, organizationId, resetList } = action.payload;
            const bucketIds = buckets.map(bucket => bucket.id);
            const previousBuckets = resetList ? {} : state[organizationId];

            if (state[organizationId]) {
                return {
                    ...state,
                    [organizationId]: [...previousBuckets, ...bucketIds],
                };
            }

            return {
                ...state,
                [organizationId]: [...bucketIds],
            };
        case organizationConstants.NEW_BUCKET_SUCCESS:
            const bucket = action.payload;
            return {
                ...state,
                [bucket.organizationId]: [
                    ...state[bucket.organizationId],
                    bucket.id,
                ],
            };
        case organizationConstants.DELETE_BUCKET_SUCCESS: {
            const { bucketId } = action.payload;
            delete state[bucketId];
            return {
                ...state,
            };
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/bucketsByOrganizationReducer.js